import { Component, OnInit, ViewChild, ViewChildren, QueryList, ElementRef, ViewEncapsulation, Input, OnChanges } from '@angular/core';
import { FormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AuthService } from 'src/app/service/auth.service';
import { YukkApi } from 'src/app/service/yukkapi.service';
import { Observable } from 'rxjs';
import { map, debounceTime, shareReplay, tap, startWith } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { RoutingService } from 'src/app/service/routing.service';
import { COMMA, ENTER, SPACE } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { NewsletterSendComponent } from '../newsletter-send/newsletter-send.component';
import 'grapesjs/dist/css/grapes.min.css';
declare const grapesjs: any;
declare const CKEDITOR: any;

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-newsletter-form',
  templateUrl: './newsletter-form.component.html',
  styleUrls: ['./newsletter-form.component.scss']
})
export class NewsletterFormComponent implements OnChanges {

  @ViewChild('inputNewsletterTitle', { static: false, read: ElementRef }) titleField: ElementRef;
  @ViewChild('selectorNewsletterFrequency', { static: false }) frequencyField: MatSelect;
  @ViewChild('selectorNewsletterContents', { static: false }) contentsField: MatSelect;
  @ViewChild('inputNewsletterPhrase', { static: false, read: ElementRef }) phraseField: ElementRef;

  @ViewChildren('selectorNewsletterObject') newsletterObjectSelectorFields: QueryList<MatSelect>;
  @ViewChildren('inputNewsletterObject') newsletterObjectInputFields: QueryList<ElementRef>;

  public selectedEmail = 'myEmail';
  email: string;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER];
  emailList = [];

  // max size of the uploaded file
  fileMaxSize = 2500000;

  frequency = [
    { value: 'DAILY', valueName: 'Daily (approx. 08:30 AM)' },
    { value: 'WEEKLY', valueName: 'Weekly (Friday, approx. 08:40 AM)' },
    { value: 'MONTHLY', valueName: 'Monthly (1st of the Month, approx. 08:50 AM)' },
    { value: 'QUARTERLY', valueName: 'Quarterly (1st of the Quarter, approx. 09:00 AM)' },
  ];

  frequency_time = [
    { value: 'MORNING', valueName: 'Morning' },
    { value: 'AFTERNOON', valueName: 'Afternoon' },
    { value: 'EVENING', valueName: 'Evening' },
  ];

  include = [
    { value: 'curated_news', valueName: 'Bookmark News' },
    { value: 'recommended_news', valueName: 'Recommended News' },
    { value: 'top_news', valueName: 'Top News' },
    { value: 'all_news', valueName: 'All News' },
    { value: 'stories', valueName: 'Stories' },
    // { value: 'significant_events', valueName: 'Significant Events' },
  ];

  setContents = null;

  design = [
    { value: 'snippet', valueName: 'News Snippets' },
    { value: 'chart', valueName: 'Chart' },
    { value: 'hide_sentiment_bars', valueName: 'Hide Sentiment Bars' }
  ];

  setDesign = [];

  setScoreType = 'sentiment';

  defaultFromEmail = 'product@yukkalab.com';

  selectedTemplate = null;
  hideSignature = true;
  showCode = false;

  mjmlTemplates = [
    { name: 'Custom', value: '' },
    { name: 'Simple Text', value: '<mj-text font-size="13px" color="#999999" font-family="Helvetica, sans-serif">With best Regards, Your Newsletter.</mj-text>' },
    { name: 'Styled Signature', value: '<mj-text font-size="13px" color="#999999" font-family="Helvetica, sans-serif">With best Regards,</mj-text><mj-text font-size="13px" color="#999999" font-family="Comic Sans MS, Comic Sans, cursive" font-style="italic">Your Newsletter</mj-text>' },
    { name: 'Image above Text', value: '<mj-image src="https://yl-newsletters-logos-v1.s3.amazonaws.com/Logo_YUKKA_News-Analytics_Transparent.png"></mj-image><mj-divider border-color="#999999"></mj-divider><mj-text font-size="13px" color="#999999" font-family="Helvetica, sans-serif">With best Regards, Your Newsletter.</mj-text>' },
    { name: 'Image below Text', value: '<mj-text font-size="14px" color="#111" font-style="bold" font-family="helvetica">Name</mj-text><mj-text font-size="10px" color="grey" font-style="bold" font-family="helvetica">Role</mj-text><mj-text font-size="10px" color="grey" font-style="bold" font-family="helvetica">Company</mj-text><mj-divider border-color="#999999"></mj-divider><mj-image width="100px" src="https://yl-newsletters-logos-v1.s3.amazonaws.com/Logo_YUKKA_News-Analytics_Transparent.png"/>' },
    { name: 'Social Icons and Address', value: '<mj-text padding="5px 0 0 25px" color="#000000" font-family="Arial, Helvetica, sans-serif" font-weight="bold">Stay connected</mj-text><mj-social icon-size="30px" border-radius="15px" mode="horizontal" align="left" padding="5px 0 10px 25px"><mj-social-element name="facebook-noshare" href="https://mjml.io/"></mj-social-element><mj-social-element name="google-noshare" href="https://mjml.io/"></mj-social-element><mj-social-element name="linkedin-noshare" href="https://mjml.io/"></mj-social-element><mj-social-element name="twitter-noshare" href="https://mjml.io/"></mj-social-element><mj-social-element name="instagram-noshare" href="https://mjml.io/"></mj-social-element><mj-social-element name="pinterest-noshare" href="https://mjml.io/"></mj-social-element></mj-social><mj-text padding="5px 0 0 25px" color="#000000" font-family="Arial, Helvetica, sans-serif">Company</mj-text><mj-text padding="5px 0 0 25px" color="#000000" font-family="Arial, Helvetica, sans-serif">Street address</mj-text><mj-text padding="5px 0 0 25px" color="#000000" font-family="Arial, Helvetica, sans-serif">Postal code, City</mj-text><mj-text padding="5px 0 0 25px" color="#000000" font-family="Arial, Helvetica, sans-serif">Country</mj-text>' },
  ];

  // format = [
  //   { value: 'email', valueName: 'Email/Digital' },
  //   // { value: 'pdf', valueName: 'PDF Document' },
  //   // { value: 'ppt', valueName: 'PPT Presentation' },
  //   // { value: 'word', valueName: 'Word Document' },
  // ]

  colors = ['white', 'black', 'grey'];

  loading: boolean;
  iupload: boolean;

  loadingArray: boolean[] = [];

  item$: Observable<any>;
  items$: Observable<any>[] = [];
  folio$: Observable<any>;
  query$: Observable<any>;
  filteredQueries$: Observable<any>[] = [];
  collection$: Observable<any>;

  filter$: Observable<any>;

  scores$: Observable<any>;

  folio: any;
  query: any;
  collection: any;

  scores: any;

  color: {
    primary: '#fff',
    secondary: '#000',
    tertiary: '#fefefe'
  };
  imghead: string;
  imglogo: string;
  color1 = '#2889e9';
  color2 = '#33ca33';
  search = new UntypedFormControl();
  searchFormControls = [];
  queryFormControls = [];
  background = new UntypedFormControl();
  textcolor = new UntypedFormControl();

  @Input('newsletter') newsletter: any;
  @Input('newsletterParamsReady') newsletterParamsReady: any;
  @ViewChild('gjs') gjs: ElementRef;
  @ViewChild('blocks') blocks: ElementRef;
  @ViewChild('myFrame') myFrame: ElementRef;

  constructor(
    private yukkApi: YukkApi,
    public auth: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    public routing: RoutingService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
  ) {

    // grapesJS.init({
    //   fromElement: 1,
    //   container : '#gjs',
    //   avoidInlineStyle : false,
    //   plugins: [grapesJSMJML],
    //   pluginsOpts: {
    //     [grapesJSMJML]: {/* ...options */}
    //   },
    // });

    this.folio$ = this.auth.portFolios();
    this.query$ = this.auth.getQuery();
    this.collection$ = this.auth.getGroupsQuery();

    this.filter$ = this.auth.getFilter();

    this.scores$ = this.auth.getNewsletterScores();

    this.scores$.subscribe(result => {
      this.scores = result['score_types'].filter(el => el !== 'custom');
    });
    this.folio$.subscribe(result => {
      this.folio = result;
    });
    this.query$.subscribe(result => {
      this.query = result;
      if (this.newsletter) {
        this.updateDisplayables();
      }
    });
    this.collection$.subscribe(result => {
      this.collection = result;
    });

    this.email = this.auth.authToken().email;

  }
  ngOnChanges() {

    if (this.newsletter) {
      if (this.newsletter.contents) {
        this.setContents = null;
        const contentsArray = [];
        this.setDesign = [];
        this.setScoreType = 'sentiment';
        this.newsletter.contents.forEach(item => {
          if (['curated_news', 'recommended_news', 'top_news', 'all_news', 'stories'].includes(item)) {
            contentsArray.push(item);
          } else if (['snippet'].includes(item)) {
            this.setDesign.push(item);
          } else if (item.includes('chart')) {
            const words = item.split('_');
            words.pop();
            const scoreType = words.join('_');
            this.setDesign.push('chart');
            this.setScoreType = scoreType;
          }
          this.setContents = contentsArray[0];
        });
        if (this.newsletter.hide_sentiment_bars) {
          this.setDesign.push('hide_sentiment_bars');
        }
      }

      this.emailList = this.newsletter.recipients;
      this.selectedTemplate = null;
      if (this.newsletter.signature_footer) {
        this.selectedTemplate = '';
        this.hideSignature = false;
        if (this.gjs) {
          this.generateMJML();
        }
      } else {
        this.hideSignature = true;
      }

      // this.search.valueChanges.pipe(debounceTime(1000)).subscribe(value => {
      //   if ( value && ( value.length > 1 ) ) {
      //     this.loading = true;
      //     this.item$ = this.yukkApi.search_meta(value, false).pipe(map(result => {
      //       this.loading = false;
      //       return result;
      //     }));
      //   }
      // });

      this.updateDisplayables();

    }
  }

  generateMJML() {
    // this.gjs.nativeElement.innerHTML = '<mjml><mj-body><mj-section><mj-column>' + this.newsletter.signature_footer + '</mj-column></mj-section></mj-body></mjml>';
    this.blocks.nativeElement.innerHTML = '';

    CKEDITOR.dtd.$editable.a = 1;

    const editor = grapesjs.init({
      container: '#gjs',
      fromElement: false,
      components: '<mjml><mj-body><mj-section><mj-column>' + this.newsletter.signature_footer + '</mj-column></mj-section></mj-body></mjml>',
      height: '300px',
      width: 'auto',
      plugins: ['grapesjs-mjml', 'gjs-plugin-ckeditor'],
      pluginsOpts: {
        'gjs-plugin-ckeditor': {
          position: 'center',
          options: {
            startupFocus: true,
            extraAllowedContent: '*(*);*{*}', // Allows any class and any inline style
            allowedContent: true, // Disable auto-formatting, class removing, etc.
            enterMode: CKEDITOR.ENTER_BR,
            extraPlugins: 'sharedspace,justify,colorbutton,panelbutton,font',
            toolbar: [
              { name: 'styles', items: ['Font', 'FontSize' ] },
              ['Bold', 'Italic', 'Underline', 'Strike'],
              {name: 'paragraph', items : [ 'NumberedList', 'BulletedList']},
              {name: 'links', items: ['Link', 'Unlink']},
              {name: 'colors', items: [ 'TextColor', 'BGColor' ]},
            ],
          }
        }
      },
      storageManager: false,
      panels: {
        defaults: []
      },
      blockManager: {
        appendTo: '#blocks'
      }
    });

    const panelManager = editor.Panels;
    panelManager.removePanel('devices-c');

    const blockManager = editor.BlockManager;

    blockManager.remove('mj-1-column');
    blockManager.remove('mj-2-columns');
    blockManager.remove('mj-3-columns');
    blockManager.remove('mj-hero');
    blockManager.remove('mj-wrapper');

    blockManager.get('mj-text').set({
      label: '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M18.5,4L19.66,8.35L18.7,8.61C18.25,7.74 17.79,6.87 17.26,6.43C16.73,6 16.11,6 15.5,6H13V16.5C13,17 13,17.5 13.33,17.75C13.67,18 14.33,18 15,18V19H9V18C9.67,18 10.33,18 10.67,17.75C11,17.5 11,17 11,16.5V6H8.5C7.89,6 7.27,6 6.74,6.43C6.21,6.87 5.75,7.74 5.3,8.61L4.34,8.35L5.5,4H18.5Z" /></svg><span class="block-title">Text</span>',
      attributes: {
        class: ''
      }
    });
    blockManager.get('mj-button').set({
      label: '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M13 5C15.21 5 17 6.79 17 9C17 10.5 16.2 11.77 15 12.46V11.24C15.61 10.69 16 9.89 16 9C16 7.34 14.66 6 13 6S10 7.34 10 9C10 9.89 10.39 10.69 11 11.24V12.46C9.8 11.77 9 10.5 9 9C9 6.79 10.79 5 13 5M20 20.5C19.97 21.32 19.32 21.97 18.5 22H13C12.62 22 12.26 21.85 12 21.57L8 17.37L8.74 16.6C8.93 16.39 9.2 16.28 9.5 16.28H9.7L12 18V9C12 8.45 12.45 8 13 8S14 8.45 14 9V13.47L15.21 13.6L19.15 15.79C19.68 16.03 20 16.56 20 17.14V20.5M20 2H4C2.9 2 2 2.9 2 4V12C2 13.11 2.9 14 4 14H8V12L4 12L4 4H20L20 12H18V14H20V13.96L20.04 14C21.13 14 22 13.09 22 12V4C22 2.9 21.11 2 20 2Z" /></svg><span class="block-title">Button</span>',
      attributes: {
        class: ''
      }
    });
    blockManager.get('mj-image').set({
      label: '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M19,19H5V5H19M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M13.96,12.29L11.21,15.83L9.25,13.47L6.5,17H17.5L13.96,12.29Z" /></svg><span class="block-title">Image</span>',
      attributes: {
        class: ''
      }
    });
    blockManager.get('mj-divider').set({
      label: '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M20 14H4V10H20V14Z" /></svg><span class="block-title">Divider</span>',
      attributes: {
        class: ''
      }
    });
    blockManager.get('mj-social-group').set({
      label: '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M22 13.25Q22 14.29 21.6 15.2 21.21 16.1 20.53 16.78 19.85 17.46 18.94 17.86 18.03 18.25 17 18.25 16.36 18.25 15.73 18.09 15.64 18.92 15.27 19.63 14.89 20.35 14.3 20.88 13.72 21.41 12.97 21.7 12.21 22 11.38 22 10.47 22 9.67 21.65 8.88 21.31 8.28 20.72 7.69 20.13 7.35 19.33 7 18.53 7 17.63V17.31Q7.03 17.16 7.05 17H2.83Q2.5 17 2.24 16.76 2 16.5 2 16.17V7.83Q2 7.5 2.24 7.24 2.5 7 2.83 7H5.78Q5.9 5.94 6.39 5 6.87 4.11 7.63 3.44 8.38 2.76 9.34 2.38 10.3 2 11.38 2 12.54 2 13.56 2.44 14.59 2.89 15.35 3.65 16.11 4.41 16.56 5.44 17 6.46 17 7.63V7.94Q17 8.09 16.96 8.25 18 8.25 18.91 8.64 19.83 9.03 20.5 9.71 21.21 10.38 21.6 11.29 22 12.21 22 13.25M11.37 3.25Q10.56 3.25 9.83 3.54 9.09 3.82 8.5 4.32 7.94 4.82 7.55 5.5 7.17 6.2 7.05 7H11.17Q11.5 7 11.76 7.25 12 7.5 12 7.83V11.95L12.18 11.92Q12.35 11.3 12.68 10.74 13 10.17 13.47 9.72 13.92 9.27 14.5 8.93 15.04 8.6 15.67 8.43 15.75 8 15.75 7.63 15.75 6.72 15.4 5.92 15.06 5.13 14.46 4.54 13.87 3.95 13.08 3.6 12.28 3.25 11.37 3.25M7.1 15.25Q7.55 15.25 8 15.16 8.42 15.07 8.76 14.85 9.1 14.64 9.31 14.29 9.5 13.93 9.5 13.41 9.5 12.88 9.3 12.53 9.08 12.18 8.75 11.94 8.42 11.71 8.04 11.56L7.32 11.27Q7 11.14 6.77 11 6.55 10.85 6.55 10.62 6.55 10.46 6.67 10.35 6.79 10.25 6.95 10.2 7.11 10.13 7.28 10.11 7.46 10.1 7.58 10.1 8.07 10.1 8.46 10.22 8.84 10.35 9.25 10.6V9.12Q9 9.05 8.81 9 8.61 8.95 8.42 8.92 8.22 8.89 8 8.87 7.8 8.86 7.55 8.86 7.12 8.86 6.67 8.95 6.22 9.05 5.85 9.27 5.5 9.5 5.26 9.83 5.03 10.18 5.03 10.69 5.03 11.19 5.25 11.5 5.47 11.85 5.8 12.09 6.13 12.32 6.5 12.5L7.22 12.79Q7.56 12.93 7.78 13.08 8 13.24 8 13.46 8 13.65 7.89 13.76 7.79 13.87 7.63 13.92 7.5 14 7.31 14H7Q6.41 14 5.96 13.82 5.5 13.62 5.04 13.3V14.86Q6.03 15.25 7.1 15.25M11.37 20.75Q12 20.75 12.58 20.5 13.15 20.26 13.58 19.84 14 19.41 14.25 18.84 14.5 18.27 14.5 17.63 14.5 17.07 14.31 16.56 14.13 16.05 13.8 15.65 13.46 15.24 13 14.96 12.55 14.68 12 14.56V16.17Q12 16.5 11.76 16.76 11.5 17 11.17 17H8.31Q8.25 17.31 8.25 17.63 8.25 18.27 8.5 18.84 8.74 19.41 9.16 19.84 9.59 20.26 10.16 20.5 10.73 20.75 11.37 20.75M17 17Q17.77 17 18.45 16.71 19.14 16.42 19.65 15.9 20.16 15.39 20.46 14.71 20.75 14.03 20.75 13.25 20.75 12.5 20.46 11.8 20.16 11.11 19.65 10.6 19.14 10.09 18.45 9.79 17.77 9.5 17 9.5 16.23 9.5 15.55 9.8 14.87 10.1 14.36 10.61 13.85 11.12 13.55 11.8 13.25 12.5 13.25 13.25V13.46L13.27 13.68Q13.73 13.9 14.12 14.22 14.5 14.54 14.82 14.93 15.12 15.33 15.34 15.79 15.55 16.25 15.66 16.74 16.32 17 17 17Z" /></svg><span class="block-title">Group Social</span>',
      attributes: {
        class: ''
      }
    });
    blockManager.get('mj-social-element').set({
      label: '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M18,16.08C17.24,16.08 16.56,16.38 16.04,16.85L8.91,12.7C8.96,12.47 9,12.24 9,12C9,11.76 8.96,11.53 8.91,11.3L15.96,7.19C16.5,7.69 17.21,8 18,8A3,3 0 0,0 21,5A3,3 0 0,0 18,2A3,3 0 0,0 15,5C15,5.24 15.04,5.47 15.09,5.7L8.04,9.81C7.5,9.31 6.79,9 6,9A3,3 0 0,0 3,12A3,3 0 0,0 6,15C6.79,15 7.5,14.69 8.04,14.19L15.16,18.34C15.11,18.55 15.08,18.77 15.08,19C15.08,20.61 16.39,21.91 18,21.91C19.61,21.91 20.92,20.61 20.92,19A2.92,2.92 0 0,0 18,16.08Z" /></svg><span class="block-title">Social Element</span>',
      attributes: {
        class: ''
      }
    });
    blockManager.get('mj-spacer').set({
      label: '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M10,8H6L12,2L18,8H14V16H18L12,22L6,16H10V8Z" /></svg><span class="block-title">Spacer</span>',
      attributes: {
        class: ''
      }
    });
    blockManager.get('mj-navbar').set({
      label: '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" /></svg><span class="block-title">NavBar</span>',
      attributes: {
        class: ''
      }
    });
    blockManager.get('mj-navbar-link').set({
      label: '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M3.9,12C3.9,10.29 5.29,8.9 7,8.9H11V7H7A5,5 0 0,0 2,12A5,5 0 0,0 7,17H11V15.1H7C5.29,15.1 3.9,13.71 3.9,12M8,13H16V11H8V13M17,7H13V8.9H17C18.71,8.9 20.1,10.29 20.1,12C20.1,13.71 18.71,15.1 17,15.1H13V17H17A5,5 0 0,0 22,12A5,5 0 0,0 17,7Z" /></svg><span class="block-title">NavBar Link</span>',
      attributes: {
        class: ''
      }
    });

    const html = editor.runCommand('mjml-get-code').html;
    this.myFrame.nativeElement.innerHTML = html;
    this.newsletter.signatureHTML = html;

    const mjmlContainer = editor.DomComponents.getWrapper().findType('mjml')[0];
    mjmlContainer.set({
      draggable: false,
      removable: false,
      selectable: false
    });
    const mjmlBody = editor.DomComponents.getWrapper().findType('mj-body')[0];
    mjmlBody.set({
      draggable: false,
      removable: false,
      selectable: false
    });
    const section = editor.DomComponents.getWrapper().findType('mj-section')[0];
    section.set({
      draggable: false,
      removable: false,
      selectable: false
    });
    const column = editor.DomComponents.getWrapper().findType('mj-column')[0];
    column.set({
      draggable: false,
      removable: false,
      selectable: false
    });
    editor.DomComponents.getWrapper().findType('mj-image').forEach(image => {
      image.set({
        void: false
      });
    });
    editor.DomComponents.getWrapper().findType('mj-social').forEach(image => {
      image.set({
        void: false
      });
    });

    editor.on('storage:start:store', (objectToStore) => {
      const html2 = editor.runCommand('mjml-get-code').html;
      this.myFrame.nativeElement.innerHTML = html2;
      this.newsletter.signatureHTML = html2;

      const mjmlFull = objectToStore.html;
      const mjmlPart = mjmlFull.replace('<mjml><mj-body><mj-section><mj-column>', '').replace('</mj-column></mj-section></mj-body></mjml>', '');
      this.newsletter.signature_footer = mjmlPart;
    });

    editor.on('component:add', (component) => {
      component.set({
        void: false
      });
    });

  }

  toggleEditor() {
    this.showCode = !this.showCode;
    if (!this.showCode) {
      this.generateMJML();
    }
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      const emails = this.extractEmails(value.trim());
      if (emails) {
        if ((emails.length === 1) && (emails[0] === this.email)) {
          alert('Provided email is already added to the recipients list.');
        } else {
          emails.forEach(email => {
            if ((email !== this.email) && !this.emailList.includes(email)) {
              this.emailList.push(email);
            }
          });
        }
      } else {
        alert('Error: please enter valid email.');
      }
      // const isValid = this.validateEmail(value.trim());
      // if (isValid && (value.trim() !== this.email)) {
      //   this.emailList.push(value.trim());
      // } else if (isValid && (value.trim() === this.email)) {
      //   alert('Provided email is already added to the recipients list.');
      // } else {
      //   alert('Error: please enter valid email.');
      // }
    }
    if (input) {
      input.value = '';
    }
  }

  getTemplate (event) {
    this.hideSignature = false;
    this.newsletter.signature_footer = this.mjmlTemplates.filter(item => {
      return item.value === event.value;
    }).map(item => {
      return item.value;
    })[0];
    this.generateMJML();
  }

  remove(email): void {
    const index = this.emailList.indexOf(email);
    if (index >= 0) {
      this.emailList.splice(index, 1);
    }
  }

  onSubmit(type) {
    if (this.isValid()) {

      this.newsletter.recipients = this.emailList;
      const newsletter = JSON.parse(JSON.stringify(this.newsletter));
      if (!newsletter.disclaimer || (newsletter.disclaimer === '')) {
        delete newsletter.disclaimer;
      }
      if (!newsletter.from_email || (newsletter.from_email === '')) {
        delete newsletter.from_email;
      }
      if (!newsletter.from_email_displayname || (newsletter.from_email_displayname === '')) {
        delete newsletter.from_email_displayname;
      }

      if (newsletter.signatureHTML) {
        delete newsletter.signatureHTML;
      }

      if (newsletter.recommended_news_phrases && (!newsletter.contents || (newsletter.contents && !newsletter.contents.includes('recommended_news')))) {
        delete newsletter.recommended_news_phrases;
      }
      if (newsletter.recommended_news_num_articles && (!newsletter.contents || (newsletter.contents && !newsletter.contents.includes('recommended_news')))) {
        delete newsletter.recommended_news_num_articles;
      }
      if (newsletter.recommended_news_threshold && (!newsletter.contents || (newsletter.contents && !newsletter.contents.includes('recommended_news')))) {
        delete newsletter.recommended_news_threshold;
      }

      const displayablesArray = [];

      this.newsletter.dispObjects.forEach(disp => {
        const displayable = 'ylrn:displayable:' + disp.type + ':' + disp.payload;
        displayablesArray.push(displayable);
      });

      newsletter.displayables = displayablesArray;

      newsletter['delivery_settings'] = {
        delivery_time: newsletter.delivery_time,
        frequency: newsletter.frequency
      };

      newsletter['news_settings'] = {
        all_news_max_number: newsletter.all_news_max_number,
        recommended_news_max_number: newsletter.recommended_news_num_articles,
        recommended_news_phrases: newsletter.recommended_news_phrases,
        recommended_news_threshold: newsletter.recommended_news_threshold,
        stories_max_number: newsletter.stories_max_number,
        top_news_max_number: newsletter.top_news_max_number
      };

      if (type === 'test') {

        this.dialog.open(NewsletterSendComponent, {
          data: {
            newsletter: newsletter
          }
        });

      } else {

        this.iupload = true;

        this.auth.editNewsletter(newsletter).subscribe(result => {
          this.iupload = false;
          this.router.navigate(['/cockpit/newsletter'], {
            queryParams: { id: result.uid, rdn: Math.random() },
            queryParamsHandling: 'merge',
            replaceUrl: true
          });
          // if (newsletter.contents.includes('curated_news') && !newsletter.contents.includes('top_news') && !newsletter.contents.includes('all_news')) {
          //   this.router.navigate(['/cockpit/newsletter/articles'], {
          //     queryParams: { id: result.uid, rdn: Math.random() },
          //     queryParamsHandling: 'merge',
          //     replaceUrl: true
          //   });
          // } else {
          //   this.router.navigate(['/cockpit/newsletter'], {
          //     queryParams: { id: result.uid, rdn: Math.random() },
          //     queryParamsHandling: 'merge',
          //     replaceUrl: true
          //   });
          // }
        }, error => {
          this.iupload = false;
          alert('Error: unable to save newsletter. ' + error);
        });

      }

    } else {
      alert('Error: all of the required fields must be valid.');
    }

  }

  isValid() {
    let isValid = true;
    if (!this.newsletter.title) {
      if (this.titleField) {
        this.titleField.nativeElement.focus();
      }
      isValid = false;
    }
    if (!this.newsletter.frequency) {
      if (this.frequencyField) {
        this.frequencyField.focus();
      }
      isValid = false;
    }
    if (!this.newsletter.dispObjects) {
      isValid = false;
    } else {
      const checkEl = (element) => (!element.type || !element.payload);
      const selectorFields = this.newsletterObjectSelectorFields.toArray();
      const inputFields = this.newsletterObjectInputFields.toArray();
      let indexSelector = 0;
      let indexInput = 0;
      this.newsletter.dispObjects.forEach((el, index) => {
        if (checkEl(el)) {
          isValid = false;
          if (['entity', 'search_query'].includes(el.type)) {
            inputFields[indexInput].nativeElement.focus();
            indexInput++;
          } else if (['portfolio', 'search_query_group'].includes(el.type)) {
            selectorFields[indexSelector].focus();
            indexSelector++;
          }
        }
      });
    }
    if (!this.setContents) {
      if (this.contentsField) {
        this.contentsField.focus();
      }
      isValid = false;
    }
    if (this.setContents && (this.setContents === 'recommended_news')) {
      if (!this.newsletter.recommended_news_phrases[0]) {
        if (this.phraseField) {
          this.phraseField.nativeElement.focus();
        }
        isValid = false;
      }
      if (!this.newsletter.recommended_news_num_articles || !this.isNatural(this.newsletter.recommended_news_num_articles)) {
        isValid = false;
      }
      if (!this.newsletter.recommended_news_threshold) {
        isValid = false;
      }
    }
    if (this.newsletter.from_email && !this.validateEmail(this.newsletter.from_email)) {
      isValid = false;
    }
    if (this.newsletter.from_email_displayname && !this.newsletter.from_email) {
      this.newsletter.from_email = this.defaultFromEmail;
    }
    return isValid;
  }

  isNatural(x) {
    return ((x >= 0) && (Math.floor(x) === +x));
  }

  onContentsChange(option) {
    const newContents = [];
    ['curated_news', 'recommended_news', 'top_news', 'all_news', 'stories'].forEach(item => {
      if (this.newsletter.contents.includes(item)) {
        newContents.push(item);
      }
    });
    ['snippet', 'sentiment_chart'].forEach(item => {
      if (this.newsletter.contents.includes(item)) {
        newContents.push(item);
      }
    });
    newContents[0] = option;
    if (!(option === 'recommended_news') && !this.newsletter.contents.includes('recommended_news')) {
      this.newsletter.recommended_news_phrases = [''];
      this.newsletter.recommended_news_num_articles = 50;
      this.newsletter.recommended_news_threshold = 0.05;
    }
    if ((this.newsletter.recommended_news_phrases === null) || (this.newsletter.recommended_news_num_articles === null) || (this.newsletter.recommended_news_phrases === null)) {
      this.newsletter.recommended_news_phrases = [''];
      this.newsletter.recommended_news_num_articles = 50;
      this.newsletter.recommended_news_threshold = 0.05;
    }
    this.newsletter.contents = newContents;
  }

  onDesignChange(options) {
    const newContents = [];
    ['curated_news', 'recommended_news', 'top_news', 'all_news', 'stories'].forEach(item => {
      if (this.newsletter.contents.includes(item)) {
        newContents.push(item);
      }
    });
    ['snippet', 'chart'].forEach(item => {
      if (options.includes(item)) {
        if (item === 'chart') {
          newContents.push(this.setScoreType + '_chart');
        } else {
          newContents.push(item);
        }
      }
    });
    this.newsletter.contents = newContents;
    if (options.includes('hide_sentiment_bars')) {
      this.newsletter.hide_sentiment_bars = true;
    } else {
      this.newsletter.hide_sentiment_bars = false;
    }
  }

  onScoreTypeChange(score) {
    const newContents = [];
    ['curated_news', 'recommended_news', 'top_news', 'all_news', 'stories'].forEach(item => {
      if (this.newsletter.contents.includes(item)) {
        newContents.push(item);
      }
    });
    newContents.push(score + '_chart');
    this.newsletter.contents = newContents;
  }

  validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  extractEmails (text) {
    return text.match(/(?:[a-z0-9+!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gi);
  }

  optSelectArray(index, option) {
    this.searchFormControls[index].setValue(option.entity.name);
    this.newsletter.dispObjects[index].payload = option.entity.type + ':' + option.entity.alpha_id;
    this.newsletter.dispObjects[index].view = option.entity.name;
    this.router.navigate([], {
      queryParams: { updateArticles: Math.random() },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  optSelect2Array(index) {
    this.newsletter.dispObjects[index].view = '';
    this.newsletter.dispObjects[index].payload = '';
    this.searchFormControls[index].setValue('');
    this.router.navigate([], {
      queryParams: { updateArticles: Math.random() },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  optSelect3Array(index, event, type) {
    let name = '';
    if (type === 'portfolio') {
      name = this.folio.filter(element => {
        return element.uid === event.value;
      })[0].name;
    } else if (type === 'query') {
      name = this.query.filter(element => {
        return element.uid === event.value;
      })[0].name;
    } else if (type === 'collection') {
      name = this.collection.filter(element => {
        return element.uid === event.value;
      })[0].name;
    }
    this.newsletter.dispObjects[index].view = name;
    this.router.navigate([], {
      queryParams: { updateArticles: Math.random() },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  delDisplayable(index) {
    this.newsletter.dispObjects.splice(index, 1);
    this.updateDisplayables();
  }

  addDisplayable() {
    this.newsletter.dispObjects.push({
      type: 'entity',
      payload: '',
      view: ''
    });
    this.updateDisplayables();
  }

  updateDisplayables() {
    this.searchFormControls = [];
    this.queryFormControls = [];
    this.loadingArray = [];
    this.items$ = [];
    this.filteredQueries$ = [];

    this.newsletter.dispObjects.forEach((displayable, index) => {
      let name2 = '';
      const searchForm = new UntypedFormControl();
      searchForm.setValue('');
      this.searchFormControls.push(searchForm);

      this.queryFormControls.push(new UntypedFormControl());

      if (displayable.type === 'entity' && displayable.payload) {
        this.yukkApi.isentiment(
          {
            type: displayable.payload.split(':')[0],
            id: displayable.payload.split(':')[1]
          },
          false
        ).subscribe(result => {
          this.searchFormControls[index].setValue(result.entity.name);
          this.newsletter.dispObjects[index].view = result.entity.name;
        });
      } else if (displayable.type === 'portfolio' && displayable.payload) {
        name2 = this.folio ? this.folio.filter(element => {
          return element.uid === displayable.payload;
        })[0].name : '';
        this.newsletter.dispObjects[index].view = name2;
      } else if (displayable.type === 'search_query' && displayable.payload) {
        const query2 = this.query ? this.query.filter(element => {
            return element.uid === displayable.payload;
          })[0] : {};
        name2 = this.query ? this.query.filter(element => {
          return element.uid === displayable.payload;
        })[0].name : '';
        this.queryFormControls[index].setValue(query2);
        this.newsletter.dispObjects[index].view = name2;
      } else if (displayable.type === 'search_query_group' && displayable.payload) {
        name2 = this.collection ? this.collection.filter(element => {
          return element.uid === displayable.payload;
        })[0].name : '';
        this.newsletter.dispObjects[index].view = name2;
      }
    });

    this.loadingArray.length = this.newsletter.dispObjects.length;
    this.items$.length = this.newsletter.dispObjects.length;
    this.filteredQueries$.length = this.newsletter.dispObjects.length;

    this.searchFormControls.forEach((searchForm, index) => {
      this.searchFormControls[index].valueChanges.pipe(debounceTime(1000)).subscribe(value => {
        if ( value && ( value.length > 1 ) ) {
          this.loadingArray[index] = true;
          this.items$[index] = this.yukkApi.search(value, false).pipe(map(result => {
            this.loadingArray[index] = false;
            return result;
          }));
        }
      });
    });

    if (this.query) {
      this.queryFormControls.forEach((queryForm, index) => {
        this.filteredQueries$[index] = this.queryFormControls[index].valueChanges
          .pipe(
            tap(value => {
              this.newsletter.dispObjects[index].view = value['name'];
              this.newsletter.dispObjects[index].payload = value['uid'];
            }),
            startWith(''),
            map(value => typeof value === 'string' ? value : value['name']),
            map(value => value ? this.elementMatches(this.query, value) : this.query.slice())
          );
      });
    }

  }

  /**
   * returns matching items
   */
  elementMatches(options, value) {
    const filterValue = value.toLowerCase();
    return options.filter(item => item.name.toLowerCase().indexOf(filterValue) === 0);
  }

  displayFn(element) {
    return (element && element.name) ? element.name : '';
  }

  inHeader(event) {
    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].size <= this.fileMaxSize) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.newsletter.header_image = e.target.result;
          // this.newsletter.header_image_data = e.target.result
        };
        reader.readAsDataURL(event.target.files[0]);
      } else {
        alert('Error: Banner size cannot exceed 2.5 MB.');
      }
    }
  }

  inLogo(event) {
    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].size <= this.fileMaxSize) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.newsletter.logo = e.target.result;
        };
        reader.readAsDataURL(event.target.files[0]);
      } else {
        alert('Error: Logo size cannot exceed 2.5 MB.');
      }
    }
  }

  /**
   *
   */
  iMatch(entity) {
    if (entity.matched_form) {
      return entity.name.charAt(0).toLowerCase() !== entity.matched_form.charAt(0);
    }
  }

  /**
   * format big numbers >999 into K, M, ...
   */
  numberFormat(num) {
    // @ts-ignore
    return Intl.NumberFormat('en', { notation: 'compact' }).format(num);
  }

}
